<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar status / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <div
                                    class="card-header py-3 mb-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary"> Atualizar status </h6>
                                </div>
                                  <div class="row mb-3">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Status atual*</label>
                                            <input type="text" class="form-control" disabled v-model="client.status.status" >
                                        </div>
                                    </div>
                                <form @submit="update">

                                    <div class="row">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Novo status*</label>
                                            <select class="form-control" v-model="client_status.status">
                                                <option value="" disabled selected>Escolha uma opção</option>
                                                <option v-for="(s,index) in status" :key="index" :value="s.status">{{ s.status }}</option>
                                            </select>
                                        </div>
                                    </div>
                                     <div class="row mt-3 mb-4">
                                        <div class="col-lg-12 col-xs-12 col-sm-12">
                                            <label for="">Observações</label>
                                            <editorText @update-text="updateObservation"
                                                :modelValue="client_status.observation" placeholderSend="Sem observações" ref="myChild"></editorText>
                                        </div>
                                    </div>
                                      <br> <br>
                                    <div class="row mt-4">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <button type="button" @click="cancel" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i> Cancelar</button>
                                        </div>
                                    </div>
                                </form>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <div
                                    class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary">Histórico de status</h6>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Status</th>
                                                        <th>Alterado por</th>
                                                        <th>Observações</th>
                                                        <th class="text-center">Data</th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(status, index) in client_status_save" :key="status.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ status.name }} </td>
                                                         <td>{{ status.user }} </td>
                                                        <td v-if="status.observation" v-html="status.observation"></td>
                                                        <td v-else>Sem observações</td>
                                                        <td class="text-center">{{ status.created_at_formatted }}</td>
                                                    </tr>
                                                    <tr v-show="client_status_save.length <= 0">
                                                        <td colspan="5" class="text-center">Nenhum registro encontrado
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import tabMenuClient from './tab-menu-client.vue';
import editorText from '../util/editor-text.vue';


export default {
    directives: { mask },
    components: { Loading,editorText, tabMenuClient },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {status:''},
            client_status_save: {},
            client_id: '',        
            client_status: {
                id: '',
                status: '',
                observation: ''
            },
            enable_error_list: false,
            errors: [],
            status:[]

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_status.status != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        this.getStatusClient();
        this.loadStatus();

    },
    methods: {
        onCancel() { },
        cancel() {
            this.action_save = false;
            this.client_status = { };
            this.client_status_save = {};
            this.getStatusClient();
        },
        setCapitalize(text) {
            return capitalize(text);
        },
        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
         updateObservation(observation) {
           this.client_status.observation = observation;
        },
         loadStatus() {
            this.isLoading = true;

            api.get('/client-status')
                .then((response) => {
                    this.isLoading = false;
                    this.status = response.data.data;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        getStatusClient() {
            this.isLoading = true;
            api.get('/client/' + this.client_id + '/status')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client_status_save = response.data.status_client;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },
        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client/' + this.client.id + '/status', this.client_status)
                .then(() => {
                    this.isLoading = false;
                     this.$notify({
                            title: "Sucesso",
                            text: "O status do cliente foi atualizado com sucesso!",
                            type: 'success'
                        });

                    this.cancel();

                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        },
        editService(service_id) {
            this.text_label = 'Atualizar serviço';
            this.button_action = 'Atualizar';
            this.client_status_save.forEach(service => {
                if (service.id == service_id) {

                    this.client_status.service_id = service.id_service;
                    this.client_status.employees = service.employees ? service.employees.toString() : '';
                    if (service.pro_labore) {
                        this.client_status.pro_labore = service.pro_labore ? '1' : '0';
                    }

                    if (service.emission_nf) {
                        this.client_status.emission_nf = service.emission_nf ? '1' : '0';
                    }

                    if (service.signed_contract) {
                        this.client_status.signed_contract = service.signed_contract ? '1' : '0';
                    }


                }
            });
        },
       deleteService(id) {
            this.$confirm(
                {
                    message: 'Deseja retirar o serviço do cliente?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('client/' + id+'/service')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Serviço removido com sucesso",
                                        type: 'success'
                                    });
                                   
                                    this.cancel();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped></style>